module.exports = __webpack_public_path__ + "static/media/hanyang.4761a139.png";